import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ProdutoFidelidade } from 'src/app/models/produto-fidelidade';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FidelidadeProdutoService } from 'src/app/services/fidelidade-produto.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarProdutoFidelidadeModalComponent } from './cadastrar-produto-fidelidade-modal/cadastrar-produto-fidelidade-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-produto-fidelidade-modal',
  templateUrl: './produto-fidelidade-modal.component.html',
  styleUrls: ['./produto-fidelidade-modal.component.scss']
})
export class ProdutoFidelidadeModalComponent implements OnInit {

  produtos: ProdutoFidelidade[] = [];
  produtosFiltrados: ProdutoFidelidade[] = [];
  carregando = true;
  campoOrdenacao = 'produto';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<ProdutoFidelidadeModalComponent>, 
    private carregandoService: CarregandoService, 
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService, 
    @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    private fidelidadeProdutoService: FidelidadeProdutoService,
    private paginatorService: PaginatorService
  ) {}

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarProdutosFidelidade();
  }

  buscarProdutosFidelidade() {
    this.carregandoService.mostra('buscarProdutosFidelidade');

    this.fidelidadeProdutoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc')).subscribe((data: any) => {
      this.produtosFiltrados = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarProdutosFidelidade');
    }, (erro) => {
      this.carregandoService.esconde('buscarProdutosFidelidade');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
     this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutosFidelidade();
  }

  fechar() {
    this.dialogRef.close();
  }

  excluirItem(idProduto) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Produto?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.fidelidadeProdutoService.excluir(idProduto).subscribe(resp => {
          this.notificacaoService.sucesso('Produto excluído com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarProdutosFidelidade();
        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarProdutoFidelidadeModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: ProdutoFidelidade) => {
      if (result) {
        this.buscarProdutosFidelidade();
      }
    });
  }

  editarItem(idProduto) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarProdutoFidelidadeModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idProduto: idProduto },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: ProdutoFidelidade) => {
      if (result) {
        this.buscarProdutosFidelidade();
      }
    });
  }

  ordenaItens() {
    this.produtos = this.produtos.sort((a, b) => {
      return this.compare(Number(a.id), Number(b.id), true);
    });

  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}